import React from 'react';
import { FadeIn, Section, SectionLabel } from './UI';
export const ProblemSection = () => {
  return <>
      <Section className="bg-brand-grayBg" data-id="element-98">
        <FadeIn data-id="element-99">
          <SectionLabel data-id="element-100">¿Te suena familiar?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-101">
            Llevas semanas buscando.
            <br data-id="element-102" />
            <span className="text-brand-purple" data-id="element-103">
              Y aún no has dado el primer paso.
            </span>
          </h2>
          <p className="mb-4 text-[1.05rem]" data-id="element-104">
            Has visto videos. Has leído artículos. Has preguntado en grupos. Y
            aun así…
          </p>

          <ul className="my-[30px]" data-id="element-105">
            {['No sabes exactamente por qué pasos empezar ni en qué orden', 'No estás seguro de qué tipo de empresa registrar para tu situación', 'Tienes miedo de cometer un error que te cueste caro — tiempo o dinero', 'Cada respuesta que encuentras genera tres preguntas nuevas', 'Sientes que el proceso es más complicado de lo que debería ser'].map((item, i) => <li key={i} className="py-[14px] border-b border-brand-border text-[1.05rem] flex items-start gap-3" data-id="element-106">
                <span className="text-brand-pink font-bold text-[1.1rem] shrink-0 mt-[2px]" data-id="element-107">
                  ✗
                </span>
                {item}
              </li>)}
          </ul>

          <div className="bg-brand-purple text-brand-white rounded-2xl py-8 px-9 mt-[30px] text-[1.2rem] italic leading-[1.6] text-center" data-id="element-108">
            <strong className="text-brand-pink font-bold" data-id="element-109">
              El problema no es que falte información.
            </strong>
            <br data-id="element-110" />
            El problema es que hay demasiada — y ninguna te la da en orden, con
            los errores reales, para tu situación específica.
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-white" data-id="element-111">
        <FadeIn data-id="element-112">
          <SectionLabel data-id="element-113">Por qué los métodos comunes no funcionan</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-114">
            No es tu culpa que
            <br data-id="element-115" />
            <span className="text-brand-purple" data-id="element-116">sigas paralizado.</span>
          </h2>
          <p className="mb-4 text-[1.05rem]" data-id="element-117">
            Los métodos que la mayoría usa están diseñados para informar — no
            para que ejecutes.
          </p>

          <div className="overflow-x-auto mt-8" data-id="element-118">
            <table className="w-full border-collapse text-[0.97rem]" data-id="element-119">
              <thead data-id="element-120">
                <tr className="bg-brand-purple text-brand-white" data-id="element-121">
                  <th className="py-4 px-5 text-left font-semibold" data-id="element-122">
                    Método Común
                  </th>
                  <th className="py-4 px-5 text-left font-semibold" data-id="element-123">
                    Por Qué Falla
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-124">
                <tr className="bg-brand-grayBg" data-id="element-125">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-126">
                    🔍 Buscar en Google
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-127">
                    Información fragmentada, desactualizada, sin orden y
                    genérica
                  </td>
                </tr>
                <tr data-id="element-128">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-129">
                    📺 Videos de YouTube
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-130">
                    Sin secuencia, no cubren tu caso, y evitan los errores
                    reales
                  </td>
                </tr>
                <tr className="bg-brand-grayBg" data-id="element-131">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-132">
                    👥 Grupos de Facebook
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-133">
                    Opiniones contradictorias de personas que tampoco lo
                    hicieron bien
                  </td>
                </tr>
                <tr data-id="element-134">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-135">
                    💸 Contratar sin entender
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-[#c0392b] font-semibold" data-id="element-136">
                    Gastas sin saber qué compraste ni si lo estás haciendo
                    correcto
                  </td>
                </tr>
                <tr className="bg-brand-grayBg" data-id="element-137">
                  <td className="py-[14px] px-5 border-b border-brand-border" data-id="element-138">
                    ✅ <strong data-id="element-139">Ruta USA 360</strong>
                  </td>
                  <td className="py-[14px] px-5 border-b border-brand-border text-brand-purple font-semibold" data-id="element-140">
                    Proceso completo · En orden · Con los errores que debes
                    evitar
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </FadeIn>
      </Section>
    </>;
};